import React, { createContext, useContext, useState } from 'react';
import UQToastContainer from './container';
import { UQToastProps } from './index';

interface ToastContextType {
  addToast: (toast: Omit<UQToastProps, 'id' | 'onClose'>) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<UQToastProps[]>([]);

  const addToast = (toast: Omit<UQToastProps, 'id' | 'onClose'>) => {
    const id = Math.random().toString(36).substr(2, 9);
    const position = toast.position ?? 'bottom-right';
    setToasts((prev) => [
      ...prev,
      { id, ...toast, position, onClose: removeToast }
    ]);

    if (toast.duration) {
      setTimeout(() => removeToast(id), toast.duration);
    }
  };

  const removeToast = (id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <UQToastContainer toasts={toasts} onClose={removeToast} />
    </ToastContext.Provider>
  );
};

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};